module.exports = __webpack_public_path__ + "static/media/dharmachakra.529dd9e3.svg";